import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { injectQueryClient } from '@tanstack/angular-query-experimental';
import { catchError, Observable, throwError } from 'rxjs';
import { AppState } from '../store';
import { infoToastAction } from '../store/actions/toast.actions';
import { AuthService } from '../services/auth.service';
import { RedirectService } from '../services/redirect.service';

export const errorInterceptor = (
  req: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {
  const store = inject(Store<AppState>);
  const router = inject(Router);
  const authService = inject(AuthService);
  const redirectService = inject(RedirectService);
  const queryClient = injectQueryClient();

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        // Save current URL before redirecting to login
        const currentUrl = router.url;
        console.log('🔴 401 Error - Current URL:', currentUrl);
        redirectService.saveRedirectUrl(currentUrl);

        // Redirect to the login page
        store.dispatch(
          infoToastAction({
            autohide: true,
            delay: 4000,
            placement: 'top-end',
            message:
              'Your current session is expired. You will be redirected to your homepage',
          }),
        );
        console.log('🔴 Clearing user data');
        authService.clearUserData();
        console.log('🔴 Navigating to login');
        router.navigate(['/'], {
          queryParams: { a: 'login' },
        });
        queryClient.clear();
      }

      return throwError(error);
    }),
  );
};
